import type { BlobLike } from "@pdfking/compatibility"

export const BlobNative = async (blob: BlobLike): Promise<Blob> => {
  if (blob instanceof Blob) return blob
  return new Blob([await blob.arrayBuffer()], { type: blob.type })
}
